import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';
import { withStyles, withTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

const styles = {
  textArea: {
    fontFamily: 'Roboto Mono',
    fontSize: 14,
    lineHeight: '21px'
  },
  title: {
    fontSize: 14
  }
};

// One side of a text comparison: a header row (side, title, Clear) above the text
class TextInputPane extends Component {
  static propTypes = {
    left: bool,
    onChangeTitle: func,
    onChangeClip: func,
    classes: object,
    title: string,
    clip: string,
    theme: object
  };

  render() {
    const { left, theme, onChangeTitle, title, classes, clip, onChangeClip } = this.props;
    const side = left ? 'left' : 'right';

    return (
      <Paper
        style={{
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          ...theme.palette.clipBackground
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '2px 4px 2px 12px',
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
          }}
        >
          <span style={{ fontSize: 13, color: theme.palette.text.secondary }}>
            {left ? 'Original' : 'Changed'}
          </span>
          <TextField
            id={`${side}-clip-title-input`}
            placeholder="Title (optional)"
            style={{ flexGrow: 1 }}
            onChange={e => onChangeTitle(e.target.value)}
            value={title}
            InputProps={{ disableUnderline: true, classes: { root: classes.title } }}
          />
          <Button
            id={`${side}-clip-clear-button`}
            size="small"
            onClick={() => onChangeClip('')}
            style={{ textTransform: 'none', minWidth: 0 }}
          >
            Clear
          </Button>
        </div>
        <TextField
          id={`${side}-clip-input`}
          placeholder="Enter or paste text here."
          multiline
          rows={16}
          rowsMax={24}
          style={{ width: '100%', padding: '8px 12px', boxSizing: 'border-box' }}
          InputProps={{ disableUnderline: true, classes: { root: classes.textArea } }}
          value={clip}
          onChange={e => onChangeClip(e.target.value)}
        />
      </Paper>
    );
  }
}

export default withTheme()(withStyles(styles)(TextInputPane));
